import { render, staticRenderFns } from "./CurrentOrdersTable.vue?vue&type=template&id=2a14e024&scoped=true"
import script from "./CurrentOrdersTable.vue?vue&type=script&lang=js"
export * from "./CurrentOrdersTable.vue?vue&type=script&lang=js"
import style0 from "./CurrentOrdersTable.vue?vue&type=style&index=0&id=2a14e024&prod&scoped=true&lang=scss"
import style1 from "./CurrentOrdersTable.vue?vue&type=style&index=1&id=2a14e024&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a14e024",
  null
  
)

export default component.exports